import React from 'react'
import axios from "axios";

import en from '../../../locales/en/translation.json';
import fr from '../../../locales/fr/translation.json';

import avantage from '../../../assets/logos/avantage_icon.svg';
import postuler from '../../../assets/logos/postuler.svg';
import postuleren from '../../../assets/logos/postuler_en.svg';

export default class Emplois extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: 'en',
            trad: en,
            engeneering: [],
            marketing: [],
        }
    }

    componentDidMount() {
        if (JSON.parse(localStorage.getItem("user"))) {
            this.setState({
                user: JSON.parse(localStorage.getItem("user")),
            }, () => {
                let lang = this.state.user.user.language;
                if (lang === "fr") {
                    this.setState({lang: "fr", trad: fr});
                }
            });
        }
        let marketing = [];
        let engeneering = [];
        axios.get(import.meta.env.VITE_BACKEND_URL + '/emploi/get').then((res) => {
            if (res.data) {
                res.data.map((emploi) => {
                    if (emploi.categorie === "ENGINEERING") {
                        engeneering.push(emploi);
                    } else if (emploi.categorie === "MARKETING & COMMUNICATIONS") {
                        marketing.push(emploi);
                    }
                });
                this.setState({engeneering, marketing});
            }
        }).catch((error) => {
            console.log(error);
        });

    }

    render() {
        const {lang, trad} = this.state;
        return (
            <div className="emplois_page">
                <div className="titre">
                    <h1>{trad.emploiTitle}</h1>
                    <p>{trad.emploiBaseline}</p>
                </div>
                <div className="avantages">
                    <h2>{trad.emploiSousTitle}</h2>
                    <div className="block_avantages">
                        <div className="block_avantage">
                            <img src={avantage} alt=""/>
                            <p>{trad.emploiavan01}</p>
                        </div>
                        <div className="block_avantage">
                            <img src={avantage} alt=""/>
                            <p>{trad.emploiavan02}</p>
                        </div>
                        <div className="block_avantage">
                            <img src={avantage} alt=""/>
                            <p>{trad.emploiavan03}</p>
                        </div>
                        <div className="block_avantage">
                            <img src={avantage} alt=""/>
                            <p>{trad.emploiavan04}</p>
                        </div>
                    </div>
                </div>
                <div className="marketing">
                    <h2>Marketing & Communications</h2>
                    <div className="block_emploi">
                        {this.state.marketing.map((emploi, index) => {
                            return (
                                <div className="emploi" key={index}>
                                    <h3>{lang === "en" ? emploi.titre_en : emploi.titre}</h3>
                                    <p>
                                        {lang === "en" ? `${emploi.lieu_en}` : `${emploi.lieu}`}
                                        <span className="round"></span>
                                        {lang == "en" ? `${emploi.type_en}` : `${emploi.type}`}
                                    </p>
                                    <button><img src={lang === "en" ? postuleren : postuler} alt=""/></button>
                                </div>
                            )
                        })}
                    </div>
                    <h2>ENGINEERING</h2>
                    <div className="block_emploi">
                        {this.state.engeneering.map((emploi, index) => {
                            return (
                                <div className="emploi" key={index}>
                                    <h3>{lang === "en" ? emploi.titre_en : emploi.titre}</h3>
                                    <p>
                                        {lang === "en" ? `${emploi.lieu_en}` : `${emploi.lieu}`}
                                        <span className="round"></span>
                                        {lang == "en" ? `${emploi.type_en}` : `${emploi.type}`}
                                    </p>
                                    <button><img src={lang === "en" ? postuleren : postuler} alt=""/></button>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }

}
